// Base configuration with common settings
const BASE_CARLEAD_CONFIG = {
  emailSuggestionEnabled: true,
  bookingUrl: '/appointment/9-0',
  confirmationUrl: '/appointment/9-0/confirmed',
  redirectOnSuccessUrl: '/booking/{hash}/',
  featuresFlags: {
    redirectToSelfEvaluation: true,
    selfEvaHideOnlinePriceBucket: true,
    exactMileage: true
  },
  stepsTimeTracking: {
    isEnabledFor: ['StepCompound'],
    options: {
      idleTimeout: 20,
      afterIDLETimeoutInMilliseconds: 10 * 1000
    }
  },
  marketingAttributes: {
    'lead-mileagetextfield-112022-v1': 1,
    'repositioning-202209-v2': 1
  },
  trackLandingPageType: 'lead',
  syncQuestionnaireFieldsToCookie: true,
  returningCustomerPopup: ['lead']
};

// Locale-specific configurations
export const DEFAULT_CARLEAD_CONFIGS = {
  'de-DE': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'de',
    featuresFlags: {
      ...BASE_CARLEAD_CONFIG.featuresFlags,
      dropOffEmailDelayInMinutes: 20
    },
    selfEvaNoBookingPageBucket: 1,
    selfEvaHideOnlinePriceBucket: 1,
    isMileageInputEnabled: true,
    minimumMileage: true
  },
  'fr-FR': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'fr',
    featuresFlags: {
      ...BASE_CARLEAD_CONFIG.featuresFlags,
      honeyPotEmail: true
    }
  },
  'de-AT': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'de-AT',
    minimumMileage: true
  },
  'es-ES': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'es'
  },
  'nl-NL': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'nl',
    featuresFlags: {
      ...BASE_CARLEAD_CONFIG.featuresFlags,
      pricingScope: 'license-plate-rounded'
    },
    licensePlateFallbackPath: '/waarde/17-1/',
    invalidLicensePlateFallbackPath: '/waarde/17-1/',
    selfEvaNoBookingPageBucket: 1,
    selfEvaHideOnlinePriceBucket: 1,
    roundedPrice: true,
    isMileageInputEnabled: true,
    unspecifiedMarketingExperiment: true
  },
  'pt-PT': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'pt',
    minimumMileage: true
  },
  'it-IT': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'it',
    selfEvaNoBookingPageBucket: 1,
    selfEvaHideOnlinePriceBucket: 1,
    roundedPrice: true,
    isMileageInputEnabled: true,
    unspecifiedMarketingExperiment: true,
    minimumMileage: true
  },
  'sv-SE': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'sv-SE',
    currency: 'SEK',
    featuresFlags: {
      ...BASE_CARLEAD_CONFIG.featuresFlags,
      pricingScope: 'license-plate-rounded'
    },
    licensePlateFallbackPath: '/varde/17-0/',
    invalidLicensePlateFallbackPath: '/varde/17-0/',
    selfEvaNoBookingPageBucket: 1,
    selfEvaHideOnlinePriceBucket: 1,
    roundedPrice: true,
    isMileageInputEnabled: true,
    unspecifiedMarketingExperiment: true
  },
  'nl-BE': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'nl-BE',
    minimumMileage: true
  },
  'fr-BE': {
    ...BASE_CARLEAD_CONFIG,
    locale: 'fr-BE',
    featuresFlags: {
      ...BASE_CARLEAD_CONFIG.featuresFlags,
      dropOffEmailDelayInMinutes: 20
    },
    marketingAttributes: {
      'lead-mileagetextfield-112022-v1': 1
    },
    selfEvaNoBookingPageBucket: 1,
    selfEvaHideOnlinePriceBucket: 1,
    isMileageInputEnabled: true,
    minimumMileage: true
  }
};
export const DEFAULT_SLIDER_SETTINGS = {
  className: 'center',
  centerMode: true,
  infinite: true,
  centerPadding: '20px',
  slidesToShow: 1,
  speed: 1000,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  pauseOnHover: true,
  slideSpacing: 20,
  variableWidth: true,
  arrows: true,
  responsive: [{
    breakpoint: 767,
    settings: {
      vertical: false,
      slidesToShow: 1
    }
  }]
};